import { Injectable, OnDestroy } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PrintListenerService implements OnDestroy {
  private onPrintEndCallback: (() => void) | null = null;

  private readonly mediaQueryList = window.matchMedia('print');
  private readonly handleAfterPrint = () => this.handlePrintEnd('afterprint');
  private readonly handleFocus = () => this.handlePrintEnd('focus');
  private readonly handleMediaChange = (event: MediaQueryListEvent) => {
    if (!event.matches) this.handlePrintEnd('mediaChange');
  };
  private readonly handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') this.handlePrintEnd('visibilitychange');
  };

  constructor() {
    window.addEventListener('afterprint', this.handleAfterPrint);
    window.addEventListener('focus', this.handleFocus);
    this.mediaQueryList.addEventListener('change', this.handleMediaChange);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  /**
   * 印刷終了時のコールバックを設定
   */
  onPrintEnd(callback: () => void) {
    this.onPrintEndCallback = callback;
  }

  /**
   * 登録済みの印刷終了コールバックを解除する。
   * callback を渡した場合は、現在登録されているコールバックと同一の場合のみ解除する
   * （後勝ちで上書きした別コンポーネントのコールバックを誤って消さないため）。
   */
  clearOnPrintEnd(callback?: () => void): void {
    if (callback === undefined || this.onPrintEndCallback === callback) {
      this.onPrintEndCallback = null;
    }
  }

  private handlePrintEnd(source: string) {
    if (this.onPrintEndCallback) {
      console.debug(`[PrintListenerService] 印刷終了（${source}）を検知`);
      this.onPrintEndCallback();
      this.onPrintEndCallback = null;
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('afterprint', this.handleAfterPrint);
    window.removeEventListener('focus', this.handleFocus);
    this.mediaQueryList.removeEventListener('change', this.handleMediaChange);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }
}
